import { api, platformApi } from '@/apis';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { addHours, startOfDay, startOfMinute, subDays } from 'date-fns';

export function useNicheCrimesAgainstStaff(
  groupType,
  groupCodes = [],
  days = 1,
) {
  const queryKey = ['nicheCrimesAgainstStaff', groupType, groupCodes, days];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: async ({ signal }) => {
      const { value: offsetHours = 0 } = await api
        .get('settings/offsetHours', { signal })
        .json();
      const endDate = startOfMinute(new Date());
      const startDate = addHours(
        subDays(
          startOfDay(endDate),
          days + (endDate.getHours() < offsetHours ? 0 : -1),
        ),
        offsetHours,
      );
      const searchParams = new URLSearchParams(
        [
          groupType && ['groupType', groupType],
          ...groupCodes.map((code) => ['groupCodes', code]),
          ['startDate', startDate.toISOString()],
          ['endDate', endDate.toISOString()],
        ].filter(Boolean),
      );

      return platformApi
        .get('niche/crimes-against-staff', { searchParams, signal })
        .json();
    },
    placeholderData: [],
    staleTime: 1000 * 60 * 60,
    enabled: !!groupType && groupCodes.length > 0,
  });

  return { query, cancel: () => queryClient.cancelQueries({ queryKey }) };
}
